import type { ApprovalsWorkflowField, WorkflowField } from '../types'

/**
 * Narrows a persisted workflow field to its matching approvals settings.
 */
export function isApprovalsWorkflowField(
  field: WorkflowField
): field is ApprovalsWorkflowField {
  return field.type === 'approvals' && field.settings.type === 'approvals'
}
